import artistData from '../../data/artist.json'

export default function Influences() {
  return (
    <div className="max-w-5xl mx-auto">
      <h2 className="text-3xl md:text-4xl font-serif text-primary mb-8 text-center">
        Künstlerische Vorbilder
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {artistData.influences.map((influence, index) => (
          <div
            key={index}
            className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300"
          >
            {/* Placeholder for influence image */}
            <div className="h-48 bg-gradient-to-br from-primary/20 to-secondary/20 flex items-center justify-center">
              <p className="font-serif text-2xl text-primary opacity-80">
                {influence.name}
              </p>
            </div>

            {/* Influence Info */}
            <div className="p-6">
              <h3 className="text-2xl font-serif text-primary mb-3">
                {influence.name}
              </h3>

              {influence.location && (
                <p className="text-sm text-neutral-500 mb-3">
                  📍 {influence.location}
                </p>
              )}

              <p className="text-neutral-700 leading-relaxed">
                {influence.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Travels Section */}
      {artistData.travels && artistData.travels.length > 0 && (
        <div className="mt-16">
          <h3 className="text-2xl font-serif text-primary mb-6 text-center">
            Künstlerische Reisen
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {artistData.travels.map((travel, index) => (
              <div
                key={index}
                className="p-4 bg-neutral-50 rounded-lg text-center border-2 border-transparent hover:border-primary/30 transition-colors"
              >
                <p className="text-neutral-700">{travel}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
